import { NeobrutalButton } from './NeobrutalButton';

type Guarantee = string;

type Props = {
  eyebrow?: string;
  title: string;
  highlight?: string;
  subtitle?: string;
  primaryLabel: string;
  primaryTo: string;
  secondaryLabel?: string;
  secondaryTo?: string;
  guarantees?: ReadonlyArray<Guarantee>;
};

export function FinalCtaSection({
  eyebrow,
  title,
  highlight,
  subtitle,
  primaryLabel,
  primaryTo,
  secondaryLabel,
  secondaryTo,
  guarantees = ['Sans carte bancaire', 'Setup 3 min', 'Support FR 24/7', 'Sans engagement'],
}: Props) {
  return (
    <section className="relative overflow-hidden bg-lime-500 py-24 md:py-28">
      <div className="mx-auto max-w-5xl px-6 text-center md:px-8">
        {eyebrow && (
          <div className="mb-6 inline-flex items-center gap-[10px] border-2 border-charcoal-800 bg-white px-[14px] py-[6px] font-marketing-mono text-[11px] font-medium uppercase tracking-[0.1em] text-charcoal-800 shadow-neobrutal-2">
            <span className="h-2 w-2 rounded-full border border-charcoal-800 bg-terracotta-500" />
            {eyebrow}
          </div>
        )}
        <h2 className="font-marketing-display text-[clamp(40px,6vw,84px)] font-bold leading-[0.95] tracking-[-0.04em] text-charcoal-950">
          {title}
          {highlight && (
            <>
              {' '}
              <span className="underline-white">{highlight}</span>
            </>
          )}
        </h2>

        {subtitle && (
          <p className="mx-auto mt-6 max-w-2xl font-marketing-body text-lg text-charcoal-800/90 md:text-xl">
            {subtitle}
          </p>
        )}

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <NeobrutalButton as="link" to={primaryTo} variant="dark" size="lg">
            {primaryLabel}
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
            >
              <path d="M5 12h14" />
              <path d="M13 6l6 6-6 6" />
            </svg>
          </NeobrutalButton>
          {secondaryLabel && secondaryTo && (
            <NeobrutalButton as="link" to={secondaryTo} variant="secondary" size="lg">
              {secondaryLabel}
            </NeobrutalButton>
          )}
        </div>

        <ul className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 font-marketing-mono text-xs font-medium uppercase tracking-[0.12em] text-charcoal-800">
          {guarantees.map((g) => (
            <li key={g} className="inline-flex items-center gap-2">
              <svg
                width="14"
                height="14"
                viewBox="0 0 16 16"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.6"
              >
                <path d="M3 8l3 3 7-7" />
              </svg>
              {g}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
